// Auto-generated by scripts/generateFactionSkinConfig.mjs
// Do not edit manually.

// eslint-disable-next-line no-unused-vars
import {FACTIONS} from '../../../constants/factions';
// eslint-disable-next-line no-unused-vars
import {PLAYER_COLORS} from '../../colors';

export const FACTION_SKINS_SUCCUBES = [{
  id: 'succubes_leader',
  factionId: FACTIONS.SUCCUBES,
  name: 'Зачаровывающая',
  priceNumens: 8000,
  skinRank: 1,
  colors: [
    PLAYER_COLORS.PURPLE,
  ]
}, {
  id: 'succubes_uprise',
  factionId: FACTIONS.SUCCUBES,
  name: 'Подстрекательница',
  priceNumens: 26000,
  skinRank: 2
}, {
  id: 'succubes_queen',
  factionId: FACTIONS.SUCCUBES,
  name: 'Императрица',
  priceNumens: 75000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.ORANGE,
  ]
}, {
  id: 'succubes_gold_legacy',
  factionId: FACTIONS.SUCCUBES,
  name: 'Пламенная искусительница',
  priceNumens: 70000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
  ],
  excludedFromChests: true
}, {
  id: 'succubes_ruby_legacy',
  factionId: FACTIONS.SUCCUBES,
  name: 'Владычица цепей',
  priceCrystals: 500,
  skinRank: 4,
  colors: [
    PLAYER_COLORS.VIOLET,
    PLAYER_COLORS.RED,
  ],
  accentColor: PLAYER_COLORS.RED,
  excludedFromChests: true
}];
